module.exports = __webpack_public_path__ + "static/media/img-3.71cb7c45.png";